import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { RtspConfig } from 'types/rtsp_config';
import { Stream, StreamSource, StreamState, StreamType } from 'types/stream';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateStreamParams = {
  name: string;
  source: StreamSource;
  stream_type: StreamType;
  gateway_id?: string | null;
  uri: string;
  insecure_disable_tls_verification?: boolean;
  status?: StreamState;
  camera_id?: string | null;
  deployment_id?: string | null;
  node?: string | null;
  rtsp_config?: RtspConfig | null;
};

export function useCreateStream({
  onSettled,
  ...options
}: UseMutationOptions<Stream, APIError, UseCreateStreamParams> = {}) {
  const queryClient = useQueryClient();
  const { client, applicationID } = useAPI();

  return useMutation({
    mutationFn: async (params) => {
      const { data } = await client.post(
        `/apps/${applicationID}/streams`,
        params
      );

      return data;
    },
    ...options,
    onSettled(...args) {
      onSettled?.(...args);
      queryClient.invalidateQueries(['streams']);
      queryClient.invalidateQueries(['video-sources']);
    },
  });
}
